<template>
    <div class="right_bottom">
        <div class="right_bottom_header">
            <div class="left_header_left">
                <img class="header_left_icon" src="@/assets/img/big_data/cgzh.png">
                <div class="header-title">成果转化量</div>
                <div class="bordline"></div>
            </div>
            <div class="left_header_right">ACHIEVEMENTS TRANSFORMATION</div>
        </div>
        <div id="right_bottom_pieChart" style="width: 410px;height: 300px;">
        </div>
        <div class="right_bottom_tips">
            <div class="tips_item">
                <div class="tips_item_box" :style="{'background-color':rightBottomData.color.license}"></div>
                专利许可
            </div>
            <div class="tips_item">
                <div class="tips_item_box" :style="{'background-color':rightBottomData.color.transfer}"></div>
                专利转让
            </div>

        </div>
    </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
    name: 'RightBottom',
    props:{
        rightBottomData:{
            type: Object,
			default: () => { }   
        }
    },
    data() {
        return {
            myChart: ''
        }
    },
    mounted() {
        const chartContainer = document.getElementById('right_bottom_pieChart');
        const chart = echarts.init(chartContainer);
        var series = [
            {
                data: this.rightBottomData.license,
                type: 'bar',
                stack: 'a',
                name: '专利许可',
                barWidth: 30, // 柱子宽度
                itemStyle: {
                    normal: {
                        color: this.rightBottomData.color.license,
                        barBorderRadius: 4,
                    },
                },
                stack: 'Ad',
                emphasis: {
                    focus: 'series',
                }
            },
            {
                data: this.rightBottomData.transfer,
                type: 'bar',
                stack: 'a',
                name: '专利转让',
                barWidth: 30, // 柱子宽度
                itemStyle: {
                    normal: {
                        color: this.rightBottomData.color.transfer,
                        barBorderRadius: 4,
                    },
                },
                stack: 'Ad',
                emphasis: {
                    focus: 'series',
                },
                label: {
                    show: true,
                    position: 'top',
                    color: '#fff',
                    formatter:(params)=>{
                        let dataIndex = params.dataIndex
                        return this.rightBottomData.license[dataIndex] + this.rightBottomData.transfer[dataIndex]
                    }
                }
            },

        ];
        const options = {
            tooltip: {
				trigger: 'axis', // 坐标轴触发
				formatter: function (params) {
					// 格式化显示内容
					var res = params[0].name + '<br/>';
                    var count = 0
					params.forEach(function (item) {
						res += item.seriesName + ': ' + item.value + '<br/>';
                        count += item.value
					});
                    res += '当前汇总：'+count
					return res;
				}
			},
            xAxis: {
                type: 'category',
                data: this.rightBottomData.year,

                axisLabel: {
                    color: '#fff'
                },
                axisTick: {
                    show: true
                },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#fff'
                    }
                }
            },
            yAxis: {
                type: 'value',
                splitArea: {
                    show: true,
                    areaStyle: {
                        color: 'rgba(76, 143, 250, 0.2)'
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        width: '2',
                        color: 'rgba(76, 143, 250, 0.2)'
                    }
                },
                axisLine: {
                    show: false,
                },

                axisLabel: {
                    show: false,
                },

            },
            series: series
        };
        chart.setOption(options);
        chart.on('click',function(params){
          console.log(params)
          let year = params.name
          let name = params.seriesName
          console.log(name+'---'+year)
          if(name == '专利转让'){
            localStorage.setItem('consoleTransferYear', year)
            window.open('#/patent/monitor','_blank')
          }
          if(name == '专利许可'){
            localStorage.setItem('consoleLicenseYear', year)
            window.open('#/patent/monitor','_blank')
          }
          
        })
    },
    methods: {

    }
}
</script>
<style lang="stylus" scoped>
.right_bottom{
    margin-top:40px;
    width: 411px;
    height: 364px;
    border-radius: 10px;
    border: 1px solid rgba(221, 252, 255, 0.2);
    background-color:rgba(221, 252, 255, 0.1);
    position: relative
    .right_bottom_tips{
        opacity: 0.8;
        display:flex;
        justify-content:space-between;
        padding: 0 100px;
        position:absolute;
        width:100%;
        bottom:22px;
        box-sizing:border-box;
        color: #FEFEFE;
        font-weight: 400;
        font-size:12.5px;
        .tips_item{
            display:flex;
            align-items:center
        }
        .tips_item_box{
            width: 14px;
            height: 14px;
            background: #8ADE83;
            border-radius: 4px;
            margin-right:5px
        }
    }
   .right_bottom_header{
        display:flex;
        height:56px;
        align-items:center;
        justify-content:space-between;
        margin-left:27px;
        margin-right:29px;
        position: relative
        .bordline{
            width:100%;
            height:1px;
            background:linear-gradient(to right,rgba(0,0,0,0)0%,#9BC1FF 50%,rgba(0,0,0,0)100%);
            position:absolute;
            bottom:0
        }
   }
    .left_header_right{
        color: #B7D2FF;
        font-size: 12px;
        font-weight: 500;
        opacity: 0.2;
    }
    .left_header_left{
       
        display:flex;
        height:56px;
        align-items:center
        .header-title{
            font-size: 21px;
            font-family: 'Alimama ShuHeiTi';
            font-weight: bold;
            color: #9BC1FF;
        }
        .header_left_icon{
            width:23px;
            height:21px;
            margin-right:15px
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/console/components/RightBottom.vue